export default __webpack_public_path__ + "static/media/home.6e46798f.png";